import axios from "../interceptors";
import { apiLessonsTableUrl, apiLessonsReportUrl, apiTranslateLessonUrl } from "../../config";

const headers = {
  "Content-Type": "application/json",
};

export const getLessonsQuery = async (params) => {
  const response = await axios.post(`${apiLessonsTableUrl}`, params, {
    headers: headers,
  });
  return response.data;
};

export const getLessonsReport = async (params) => {
  const response = await axios.post(`${apiLessonsReportUrl}`, params, {
    headers: headers,
  });
  return response.data;
};

export const translateLesson = async (lessonId, targetLanguage) => {
    const response = await axios.post(`${apiTranslateLessonUrl}${lessonId}/translate/${targetLanguage}`, {
      headers: headers
    });
    return response.data;
};

export const checkTranslationStatus = async (jobId) => {
    const response = await axios.get(`${apiTranslateLessonUrl}status/${jobId}`, {
      headers: headers
    });
    return response;
}
